import { createFileRoute, Outlet } from '@tanstack/react-router';
import { redirectIfStaffSignedIn } from '../../../../lib/guards';

// Signed-out staff pages (sign in, forgot password, invite). Each page wraps itself in AuthShell because the
// brand panel copy differs between sign-in and the invite.
export const Route = createFileRoute('/subdomain/admin/_auth')({
  beforeLoad: ({ context }) => redirectIfStaffSignedIn(context.queryClient),
  component: Outlet,
});
